<template>
  <div>
    <div>
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="showSelectDialog">添加{{ title }}描点</el-button>
      <div style="margin:20px 0">
        <vxe-table
            border
            ref="xTree"
            resizable
            show-overflow
            :data="tableList"
            :edit-config="{trigger: 'click', mode: 'cell'}">
            <vxe-column type="seq" width="40"></vxe-column>
            <vxe-column
              field="x"
              align="center"
              width="70"
              title="x坐标">
            </vxe-column>
            <vxe-column
              field="y"
              align="center"
              width="70"
              title="y坐标">
            </vxe-column>
            <vxe-column
              field="titleCn"
              align="center"
              min-width="100"
              title="中文标题">
            </vxe-column>
            <vxe-column
              field="titleEn"
              align="center"
              min-width="100"
              title="英文标题">
            </vxe-column>
            <vxe-column
              field="descriptionCn"
              align="center"
              min-width="100"
              title="中文描述">
            </vxe-column>
            <vxe-column
              field="descriptionEn"
              align="center"
              min-width="100"
              title="英文描述">
              </vxe-column>
            <vxe-column align="center" width="150"  field="blockImage" title="图片">
                <template  #default="{ row }">
                  <template v-if="row.blockImage.length > 0">
                    <div class="imageBox">
                      <el-image
                        v-for="(imgItem,index) in row.blockImage"
                        :key="index"
                        style="height: 35px;width:50px;margin:5px"
                        :src="setUrlHearder(imgItem.filePath)"
                        :preview-src-list="[setUrlHearder(imgItem.filePath)]">
                      </el-image>
                    </div>
                  </template>
                </template>
              </vxe-column>
            <!-- <vxe-column width="150" field="descriptionEn" title="英文描述" :edit-render="{placeholder: '请输入英文描述'}">
              <template #edit="{ row }">
                <vxe-input v-model="row.descriptionEn" type="text"></vxe-input>
              </template>
            </vxe-column>
            <vxe-column width="150" field="blockImageId" title="片块图片" :edit-render="{placeholder: '请输入数值'}">
              <template #edit="{ row }">
                <el-input v-model.number="row.num"  placeholder="请输入数值" @change="handInput"></el-input>
              </template>
            </vxe-column> -->
            <vxe-column title="操作" align="center" width="150" show-overflow>
              <template #default="{ row }">
                <vxe-button mode="text" :disabled="disabled" icon="vxe-icon-edit" @click="editEvent(row)"></vxe-button>
                <vxe-button mode="text" :disabled="disabled" icon="vxe-icon-delete" @click="handleRemove(row)"></vxe-button>
              </template>
            </vxe-column>
          </vxe-table>
      </div>
    </div>
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :append-to-body="true"
      v-dialogDrag
      width="700px"
      class="gridDialog"
      :visible.sync="visible">
      <el-row :gutter="15" style="margin-right: 0;">
        <el-col :span="24">
          <div>
            <span style="padding-left:20px">请点击图片进行描点，描点后编辑内容</span>
          </div>
        </el-col>
        <el-col :span="24">
          <div style="margin:20px;display: flex;justify-content: center;">
            <div ref="dotContainer" style="position: relative;width: 600px;height: 500px;">
              <el-image fit="fill" :src="backgroundImage" @click="addDot" style="width: 600px;height: 500px;cursor: pointer;"></el-image>
              <div class="point" v-for="(item,index) in dots" :key="index" :style="{top:item.y+'px',left:item.x+'px'}" @mousedown.prevent.stop="onDotMouseDown($event, index)">
                <i class="el-icon-warning" style="font-size: 24px;color:#56d556"></i> <span style="color:red">{{ index + 1 }}</span>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visible = false" icon="el-icon-circle-close">关闭</el-button>
        <el-button size="small" type="primary" icon="el-icon-circle-check" @click="submitPoint()">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="编辑锚点内容"
      :close-on-click-modal="false"
      :append-to-body="true"
      destroy-on-close
      v-dialogDrag
      width="900px"
      class="gridDialog"
      :visible.sync="showEdit">
      <el-form :model="formData" size="small" ref="formData"
        label-width="120px">
        <el-row :gutter="15" style="margin-right: 0;">
          <el-col :span="12">
            <el-form-item label="中文标题" prop="titleCn"
                :rules="[
                  {required: true, message:'中文标题不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="formData.titleCn" placeholder="请填写中文标题"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="英文标题" prop="titleEn"
                :rules="[
                  {required: true, message:'英文标题不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="formData.titleEn" placeholder="请填写英文标题"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="中文描述" prop="descriptionCn"
                :rules="[
                  {required: true, message:'中文描述不能为空', trigger:'blur'}
                 ]">
                 <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="formData.descriptionCn" placeholder="请填写中文描述" ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="英文描述" prop="descriptionEn"
                :rules="[
                  {required: true, message:'英文描述不能为空', trigger:'blur'}
                 ]">
                 <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="formData.descriptionEn" placeholder="请填写英文描述" ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="24">
            <el-form-item label="片块图片" prop="blockImageId"
                :rules="[
                  {required: true, message:'片块图片不能为空', trigger:'blur'}
                 ]">
                 <ImageUploadDraggable :key="'blockImage_' + formData.x + '_' + formData.y" ref="imageUploadRef" v-model="formData.blockImage" :limit="1" :otherPrams="otherPrams" action="/unmfile/cecUnmFileupload"  tip="单个图片不要超过10M" @updateChange="handImageIds"></ImageUploadDraggable>
           </el-form-item>
        </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="showEdit = false" icon="el-icon-circle-close">关闭</el-button>
        <el-button size="small" type="primary" icon="el-icon-circle-check" @click="submitRow()">确定</el-button>
      </span>
    </el-dialog>
  </div>
  
</template>
 
<script>
import ImageUploadDraggable from '@/components/upload/ImageUploadDraggableIds'
export default {
  data () {
    return {
      imageUrl: 'http://localhost:8082/file/download?uploadPath=userdir/2024/11/&name=YONGE5.jpg',
      dots: [],
      tableList: [],
      visible: false,
      showEdit: false,
      formData: {},
      // 拖拽锚点相关状态
      draggingIndex: null,
      dragOffsetX: 0,
      dragOffsetY: 0,
      otherPrams: {
        id: '',
        type: 'portfolio_afterImage_point'
      }
    }
  },
  components: {
    ImageUploadDraggable
  },
  props: {
    title: {
      type: String,
      default: () => { return '' }
    },
    pointType: {
      type: String,
      default: () => { return '' }
    },
    valueList: {
      type: Array,
      default: () => { return [] }
    },
    backgroundImage: {
      type: String,
      default: () => { return '' }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    itemsLength () {
      return this.valueList.length
    }
  },
  beforeDestroy () {
    // 防止组件销毁后残留全局拖拽监听
    document.removeEventListener('mousemove', this.onDotMouseMove)
    document.removeEventListener('mouseup', this.onDotMouseUp)
  },
  watch: {
    valueList: {
      handler (newVal) {
        if (newVal.length > 0) {
          this.dots = this.valueList
          this.tableList = this.valueList
        }
      }
    },
    itemsLength: {
      handler (newVal) {
        if (newVal === 0) {
          this.dots = []
          this.tableList = []
        }
      }
    },
    immediate: false,
    deep: true
  },
  methods: {
    // 拼接url
    setUrlHearder (url) {
      return url.indexOf('http') >= 0 ? url : process.env.VUE_APP_SERVER_URL + url
    },
    // 上传返回ids
    handImageIds (e) {
      this.formData.blockImageId = e
      this.formData.blockImage = this.$refs.imageUploadRef.defaultFileList.map(item => {
        item.filePath = item.url
        return item
      })
    },
    addDot (event) {
      const dot = {
        x: String(event.offsetX - 10),
        y: String(event.offsetY - 10),
        titleEn: '',
        titleCn: '',
        descriptionCn: '',
        descriptionEn: '',
        blockImageId: '',
        blockImage: [],
        type: this.pointType
      }
      this.dots.push(dot)
    },
    // 锚点按下，开始拖拽
    onDotMouseDown (event, index) {
      const container = this.$refs.dotContainer
      if (!container) return
      const rect = container.getBoundingClientRect()
      this.draggingIndex = index
      // 记录鼠标按下点相对锚点左上角的偏移，保证拖拽时锚点不会瞬间跳到鼠标处
      this.dragOffsetX = event.clientX - rect.left - Number(this.dots[index].x)
      this.dragOffsetY = event.clientY - rect.top - Number(this.dots[index].y)
      document.addEventListener('mousemove', this.onDotMouseMove)
      document.addEventListener('mouseup', this.onDotMouseUp)
    },
    // 拖拽移动中，实时更新坐标
    onDotMouseMove (event) {
      if (this.draggingIndex === null) return
      const container = this.$refs.dotContainer
      if (!container) return
      const rect = container.getBoundingClientRect()
      let newX = event.clientX - rect.left - this.dragOffsetX
      let newY = event.clientY - rect.top - this.dragOffsetY
      // 限制在容器范围内（预留图标尺寸，避免拖出图片）
      const maxX = rect.width - 20
      const maxY = rect.height - 20
      newX = Math.max(0, Math.min(newX, maxX))
      newY = Math.max(0, Math.min(newY, maxY))
      const dot = this.dots[this.draggingIndex]
      this.$set(dot, 'x', String(Math.round(newX)))
      this.$set(dot, 'y', String(Math.round(newY)))
    },
    // 拖拽结束，解绑事件
    onDotMouseUp () {
      this.draggingIndex = null
      document.removeEventListener('mousemove', this.onDotMouseMove)
      document.removeEventListener('mouseup', this.onDotMouseUp)
    },
    showSelectDialog () {
      if (!this.backgroundImage) {
        this.$message.error('请先上传' + this.title + '图片')
      } else {
        this.visible = true
      }
    },
    submitPoint () {
      this.tableList = this.dots
      this.visible = false
    },
    handleRemove (data) {
      this.dots.splice(this.dots.findIndex(item => item.x === data.x && item.y === data.y), 1)
    },
    editEvent (row) {
      this.formData = {
        x: row.x,
        y: row.y,
        descriptionCn: row.descriptionCn,
        descriptionEn: row.descriptionEn,
        titleEn: row.titleEn,
        titleCn: row.titleCn,
        blockImageId: row.blockImageId,
        blockImage: row.blockImage,
        type: row.type
      }
      this.showEdit = true
    },
    submitRow () {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          this.tableList.forEach(item => {
            if (item.x === this.formData.x && item.y === this.formData.y) {
              item.x = this.formData.x
              item.y = this.formData.y
              item.descriptionCn = this.formData.descriptionCn
              item.descriptionEn = this.formData.descriptionEn
              item.titleEn = this.formData.titleEn
              item.titleCn = this.formData.titleCn
              item.blockImageId = this.formData.blockImageId
              item.blockImage = this.formData.blockImage
              item.type = this.formData.type
            }
          })
          this.showEdit = false
        }
      })
    }
  }
}
</script>
<style scoped>
.point{
  position: absolute;
  /* width: 30px; */
  /* height: 30px; */
  /* background-color: red; */
  /* border-radius: 50%; */
  z-index: 1000 ;
  display: flex;
  align-items: center;
  cursor: move;
  user-select: none;
}
</style>